import { productCategories } from "@/data/productCategories";
import { routes } from "@/data/routes";

const headerData: HeaderData = {
  colors: {
    transparent: {
      header: "bg-[rgba(0,0,0,0.3)] border-b border-b-transparent",
      text: "text-white fill-white",
    },
    default: {
      header: "bg-white shadow-xs",
      text: "text-foreground",
    },
  },
  scrollThreshold: 128,
  links: [
    {
      path: routes.products.path,
      label: "PRODUCTS",
      subLinks: productCategories,
    },
    {
      path: routes.about.path,
      label: "ABOUT",
    },
    {
      path: routes.contact.path,
      label: "CONTACT",
    },
    {
      path: routes.stores.path,
      label: "STORES",
    },
  ],
};

export default headerData;

type HeaderData = {
  colors: {
    transparent: {
      header: string;
      text: string;
    };
    default: {
      header: string;
      text: string;
    };
  };
  scrollThreshold: number;
  links: {
    path: string;
    label: string;
    subLinks?: {
      path: string;
      label: string;
      sidebarImage: string;
      carouselImage: string;
    }[];
  }[];
};
